import { Configurable, forBrand, environment } from "@crystal/config";
const config = Configurable.props({
  clientId: forBrand({
    adidas: environment({
      default: "OTYNSQFGLOH0K6PEKRCYBH6SHVSV6CBO",
      // 'api_portal_dev_test_redirectless'
      production: "LUJ5J74JY3NJDFZ0GTAOSTU5PRJY2Q57"
    }),
    reebok: environment({
      default: "U3KYKNV4OCCWS7F998K42DPO1O7BBOGT"
    })
  }),
  serviceLayerApiKey: environment({
    default: "25XG6JBjykavcfeEtLUFA58jDt5OGYlx7xl3Hw9t",
    production: "hWtdkyHM947mWvlXfLexA2Z0bsFQ6Jo5aAJaMwvh"
  })
});
export {
  config
};
//# sourceMappingURL=config.js.map
